import axios         from "axios";
import config        from "../config/config"
import {SearchTypes} from "@/util/enums/SearchTypes";

export default class Search {
    public static async getResults(query: string, type: SearchTypes) {
        return await axios.get(config.API_URL + '/v1/search', {
                params: {
                    query: query,
                    type : type,
                }
            }
        );
    }
}